export const STREAMING_CHUNK_MS = 50;

export const downsampleToPcm16 = (input, inputSampleRate, outputSampleRate = 16000) => {
  if (!input?.length) return new ArrayBuffer(0);
  const ratio = inputSampleRate / outputSampleRate;
  const newLength = Math.round(input.length / ratio);
  const result = new Int16Array(newLength);
  let offsetResult = 0;
  let offsetBuffer = 0;

  while (offsetResult < result.length) {
    const nextOffsetBuffer = Math.round((offsetResult + 1) * ratio);
    let accum = 0;
    let count = 0;
    for (let i = offsetBuffer; i < nextOffsetBuffer && i < input.length; i += 1) {
      accum += input[i];
      count += 1;
    }
    const sample = Math.max(-1, Math.min(1, accum / Math.max(1, count)));
    result[offsetResult] = sample < 0 ? sample * 0x8000 : sample * 0x7fff;
    offsetResult += 1;
    offsetBuffer = nextOffsetBuffer;
  }

  return result.buffer;
};

export const appendPcm16Buffer = (pending, nextBuffer) => {
  const next = new Int16Array(nextBuffer || new ArrayBuffer(0));
  if (!next.length) return pending;
  if (!pending?.length) return next;
  const merged = new Int16Array(pending.length + next.length);
  merged.set(pending, 0);
  merged.set(next, pending.length);
  return merged;
};

export const takePcm16Chunks = (pending, samplesPerChunk) => {
  const chunks = [];
  let offset = 0;
  while (pending.length - offset >= samplesPerChunk) {
    chunks.push(pending.slice(offset, offset + samplesPerChunk).buffer);
    offset += samplesPerChunk;
  }
  return {
    chunks,
    remaining: offset > 0 ? pending.slice(offset) : pending,
  };
};

const firstNumber = (...values) => {
  const value = values.find((item) => item !== undefined && item !== null && item !== '');
  const parsed = Number(value);
  return Number.isFinite(parsed) ? Math.max(0, Math.round(parsed)) : 0;
};

export const extractTranscriptEvent = (payload) => {
  if (!payload || typeof payload !== 'object') return null;
  const words = payload.words || payload.turn?.words || [];
  const text = (
    payload.transcript
    || payload.text
    || payload.turn?.transcript
    || payload.message
    || ''
  ).trim();
  if (!text) return null;

  const type = String(payload.type || payload.message_type || payload.event || '').toLowerCase();
  const isTurn = type === 'turn';
  const isFinal = isTurn
    ? payload.end_of_turn === true
    : Boolean(payload.is_final || type.includes('final'));
  return {
    text,
    isFinal,
    providerEventId: payload.id ?? payload.turn_id ?? payload.turn_order ?? payload.audio_start ?? '',
    startedAtMs: firstNumber(payload.audio_start, payload.start, words[0]?.start),
    endedAtMs: firstNumber(payload.audio_end, payload.end, words[words.length - 1]?.end),
  };
};
